/**
 * Admin Portal → Codes: the old addresses' redirects (Codes PR-8). A bookmark to `/admin/growth`,
 * `/admin/store-access`, `/admin/codes/house` or `/admin/codes/batches[/:batchId]` lands on the
 * screen that replaced it, its query string kept (codesAreaLogic.ts LEGACY_REDIRECTS).
 *
 * Web-only (the admin SPA).
 */

import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { redirectTarget } from './codesAreaLogic';

export const CodesRedirect: React.FC<{ to: string }> = ({ to }) => {
  const params = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`${redirectTarget(to, params, search)}${hash || ''}`} replace />;
};

export default CodesRedirect;
